import './App.css';
import {Editor} from "./components/Editor/Editor";

function App() {

    return (
        <div className="App">
            <Editor/>
        </div>
    );
}

export default App;
